@if (showBanner()) {
  <div class="offline-global-banner" data-testid="offline-global-banner">
    <img
      src="assets/icons/offline-mode-indicator.svg"
      alt=""
      aria-hidden="true"
      class="offline-global-banner__icon" />
    <div class="offline-global-banner__copy">
      <span class="offline-global-banner__title">{{ offlineTitle }}</span>
      <span class="offline-global-banner__message">{{ bannerMessage() }}</span>
    </div>
  </div>
}
